import { render } from "./Deactivate2FA.vue?vue&type=template&id=2208e529&scoped=true"
import script from "./Deactivate2FA.vue?vue&type=script&lang=js"
export * from "./Deactivate2FA.vue?vue&type=script&lang=js"

import "./Deactivate2FA.vue?vue&type=style&index=0&id=2208e529&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2208e529"]])

export default __exports__